import React from "react";
import { Button } from "../../common/Button/Button";
import moment from "moment";
import Spinner from "../../common/Spinner/Spinner";
import { useEffect,useState } from "react";
import { toast } from "react-toastify";
import api from "../../utils/api";
import { getESPUser } from "../../utils/localStorage";
import { useHistory } from "react-router-dom";
import ReactDatePicker from "react-datepicker";
import Radio from "../../common/Radio/Radio.jsx";
import { DOWNLOAD_API_URL } from "../../utils/constants.js";

export default function ESPReportsContainer(props)
{
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const [fromDate, setfromDate] = useState("");
    const [toDate, settoDate] = useState("");    
    const [selectedReport, setSelectedReport] = useState("allServicesinProgressssion");

    const hideReports = () => {
        var user = getESPUser();

        if (user && user.email === "marketconnect@deasra.co.in") {
            return true;
        }

        return false;
    }

    const shouldHideReports = hideReports();


    const adjustedToDate = (date) => {
		let toDateAdjusted;
		if (date) {
			toDateAdjusted = new Date(date);

			toDateAdjusted = new Date(
				toDateAdjusted.setTime(
					toDateAdjusted.getTime() + 24 * 60 * 60 * 1000 - 1000
				)
			);
		}
		return toDateAdjusted;
	};

    const fetchFullfillmentReport = () => {
		setIsLoading(true);
		try {
			api.getFullfillmentReport({
				fromDate: fromDate,
				toDate: adjustedToDate(toDate),
                role:'extSP'
			})
            .then(({ data }) => {
                toast(data["details"], {
                    autoClose: 5000,
                    type: toast.TYPE.SUCCESS,
                });
                window.open(data["generated_file"], "_self");
                setIsLoading(false);
            })
            .catch((error) => {
                setIsLoading(false);
                toast(error["response"]["data"]["message"], {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            });
		} catch {
			setIsLoading(false);
			toast("Server error.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};

    const fetchAllServicesReport = () => {
		setIsLoading(true);
		try {
			api.getAllServicesReport({
				fromDate: fromDate,
				toDate: adjustedToDate(toDate),
                role:'extSP'
			})
				.then(({ data }) => {
					toast(data["details"], {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
					window.open(data["generated_file"], "_self");
					setIsLoading(false);
				})
				.catch((error) => {
					console.log(error.status);
					setIsLoading(false);
					toast(error["response"]["data"]["message"], {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});
		} catch {
			setIsLoading(false);
			toast("Server error.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};

    const fetchSMSTrailReport = () => {       
		setIsLoading(true);
		try {
			api.getSMSTrailReport()
            .then(({ data }) => {
                toast(data["details"], {
                    autoClose: 5000,
                    type: toast.TYPE.SUCCESS,
                });
                window.open(data["generated_file"], "_self");
                setIsLoading(false);
            })
            .catch((error) => {
                setIsLoading(false);
                toast(error["response"]["data"]["message"], {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            });
		} catch {
			setIsLoading(false);
			toast("Server error.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};

    const fetchCustomerFeedbackReport = () => {       
		setIsLoading(true);
		try {
			api.getCustomerFeedbackReport(/*{fromDate: fromDate,toDate: adjustedToDate(toDate)}*/)
            .then(({ data }) => {
                toast(data["details"], {
                    autoClose: 5000,
                    type: toast.TYPE.SUCCESS,
                });
                window.open(data["generated_file"], "_self");
                setIsLoading(false);
            })
            .catch((error) => {
                setIsLoading(false);
                toast(error["response"]["data"]["message"], {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            });
		} catch {
			setIsLoading(false);
			toast("Server error.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};

    const fetchCustomerFRTReport = () => {       
		setIsLoading(true);
		try {
			api.getCustomerFRTReport(/*{fromDate: fromDate,toDate: adjustedToDate(toDate)}*/)
            .then(({ data }) => {
                toast(data["details"], {
                    autoClose: 5000,
                    type: toast.TYPE.SUCCESS,
                });
                window.open(data["generated_file"], "_self");
                setIsLoading(false);
            })
            .catch((error) => {
                setIsLoading(false);
                toast(error["response"]["data"]["message"], {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            });
		} catch {
			setIsLoading(false);
			toast("Server error.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};

    const fetchUMCReport = () => {
        setIsLoading(true);
		try {
			api.getUMCReport(/*{fromDate: fromDate,toDate: adjustedToDate(toDate)}*/)
            .then(({ data }) => {
                toast(data["details"], {
                    autoClose: 5000,
                    type: toast.TYPE.SUCCESS,
                });
                window.open(data["generated_file"], "_self");
                setIsLoading(false);
            })
            .catch((error) => {
                setIsLoading(false);
                toast(error["response"]["data"]["message"], {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            });
		} catch {
			setIsLoading(false);
			toast("Server error.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
    }

    const onSelectedReportChange = (event) => {
		setSelectedReport(event);
	};

    const onDownloadClick=()=>{
        if(selectedReport==="allServicesinProgressssion")
        {
            fetchAllServicesReport();
        }
        else if(selectedReport==="ServicesRequestsToFullfilment")
        {
            fetchFullfillmentReport();
        }
        else if(selectedReport==="CustomerFeedback")
        {
            fetchCustomerFeedbackReport();
        }
        else if(selectedReport==="SMSReport")
        {
            fetchSMSTrailReport();
        }
        else if(selectedReport==="FRT")
        {
            fetchCustomerFRTReport();
        }
        else if(selectedReport==="UMCReport"){
            fetchUMCReport()
        }
    }
   
    return (
        <div className={`row row-container ${isLoading && "set-opacity"}`} >
			{isLoading && <Spinner className="center-screen" />}
            
            <div className="col-3">
            </div>
            <div className="col-6 spled-container">
                {/*<div className="row conv-mt10">
                    <div className="col-6 width-100">
                        <ReactDatePicker
                            dateFormat="dd/MM/yyyy"
                            selected={props.fromDate}
                            onChange={(date) =>setfromDate(date)}
                            placeholderText="From Date"
                        />
                    </div>
                    <div className="col-6 width-100">
                        <ReactDatePicker
                            dateFormat="dd/MM/yyyy"
                            selected={props.toDate}
                            onChange={(date) =>settoDate(date)}
                            placeholderText="To Date"
                        />
                    </div>
                </div>
                <div className="row conv-mt30 reports-box">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-1">
                                <Radio
                                    //label="Email"							
                                    onClick={()=>{onSelectedReportChange('allServicesinProgressssion')}}
                                    //value={'allServicesinProgressssion'}
                                    checked={selectedReport==="allServicesinProgressssion"}
                                />
                            </div>
                            <div className="col-11 conv-pt10">
                                <h5>All Services in Progression</h5>
                                <h5>(Sample File Name: ServicesInSPM-13Oct18-11.xlsx)</h5>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 conv-mt20">
                        <div className="row">
                            <div className="col-1">
                                <Radio
                                    //label="Email"							
                                    onClick={()=>{onSelectedReportChange('ServicesRequestsToFullfilment')}}
                                    value={'ServicesRequestsToFullfilment'}
                                    checked={selectedReport==="ServicesRequestsToFullfilment"}
                                />
                            </div>
                            <div className="col-11 conv-pt10">
                                <h5>Service Requests to Fullfilment</h5>
                                <h5>(Sample File Name: ReqToFulfillment-13Oct18-12.xlsx)</h5>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 conv-mt20">
                        <div className="row">
                            <div className="col-1">
                                <Radio
                                    //label="Email"							
                                    onClick={()=>{onSelectedReportChange('CustomerFeedback')}}
                                    value={'CustomerFeedback'}
                                    checked={selectedReport==="CustomerFeedback"}
                                />
                            </div>
                            <div className="col-11 conv-pt10">
                                <h5>Customer Feedback Report</h5>
                                <h5>(Sample File Name: CustomerFeedback-13Oct18-11.xlsx)</h5>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 conv-mt20">
                        <div className="row">
                            <div className="col-1">
                                <Radio
                                    //label="Email"							
                                    onClick={()=>{onSelectedReportChange('SMSReport')}}
                                    value={'SMSReport'}
                                    checked={selectedReport==="SMSReport"}
                                />
                            </div>
                            <div className="col-11 conv-pt10">
                                <h5>SMS Report</h5>
                                <h5>(Sample File Name: SMS Report -18Aug10-49.xlsx)</h5>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 conv-mt20">
                        <button 
                            type="button" 
                            className="con-btn-filled conv-float-right conv-pr20 conv-pl20"
                            onClick={() =>onDownloadClick()}>
                            Download
                        </button>
                    </div>
    </div>*/}
                    <div className="row conv-mt10">
                        <div className="col-2"> </div>
                        <div className="col-4 width-100">
                            <ReactDatePicker
                                dateFormat="dd/MM/yyyy"
                                selected={fromDate}
                                onChange={(date) =>setfromDate(date)}
                                placeholderText="From Date"
                            />
                        </div>
                        <div className="col-4 width-100">
                            <ReactDatePicker
                                dateFormat="dd/MM/yyyy"
                                selected={toDate}
                                onChange={(date) =>settoDate(date)}
                                placeholderText="To Date"
                            />
                        </div>
                        <div className="col-2"> </div>
                    </div>
                    <div class="custom-card conv-mt20">
                        <div class="form-check conv-mb60 radio-item">
							<input 
                                class="form-check-input" 
                                type="radio" 
                                name="flexRadioDefault" 
                                id="flexRadioDefault1" 
                                onClick={()=>{onSelectedReportChange('allServicesinProgressssion')}}
                                checked={selectedReport==="allServicesinProgressssion"}/>
							<label  for="flexRadioDefault1" class="conv-fontfamily-mont conv-font-w600 conv-font16 conv-txt-black form-check-label"> <span>All Services in Progression</span></label><br></br>
							<span class="conv-fontfamily-mont conv-font-w500 conv-font16 conv-txt-black ">(Sample File Name: ServicesInSPM-13Oct18-11.xlsx)</span>
						</div>
						<div class="form-check conv-mb60 radio-item">
							<input 
                            class="form-check-input" 
                            type="radio"
                            name="flexRadioDefault" 
                            id="flexRadioDefault2"
                            onClick={()=>{onSelectedReportChange('ServicesRequestsToFullfilment')}}
                            checked={selectedReport==="ServicesRequestsToFullfilment"}/>
							<label class="conv-fontfamily-mont conv-font-w600 conv-font16 conv-txt-black form-check-label" for="flexRadioDefault2"> <span> Service Requests to Fullfilment </span></label><br></br>
							<span class="conv-fontfamily-mont conv-font-w500 conv-font16 conv-txt-black ">(Sample File Name: ReqToFulfillment-13Oct18-12.xlsx)</span>
						</div>
						<div class="form-check conv-mb60  radio-item">
							<input class="form-check-input" 
                            type="radio" 
                            name="flexRadioDefault" 
                            id="flexRadioDefault3" 
                            checked
                            onClick={()=>{onSelectedReportChange('CustomerFeedback')}}
                            checked={selectedReport==="CustomerFeedback"}/>
							<label class="conv-fontfamily-mont conv-font-w600 conv-font16 conv-txt-black form-check-label" for="flexRadioDefault3"> <span>Customer Feedback Report</span></label><br></br>
							<span class="conv-fontfamily-mont conv-font-w500 conv-font16 conv-txt-black ">(Sample File Name: CustomerFeedback-13Oct18-11.xlsx)</span>
						</div>
                        <div class="form-check conv-mb60  radio-item">
							<input class="form-check-input" 
                            type="radio" 
                            name="flexRadioDefault" 
                            id="flexRadioDefault5" 
                            checked
                            onClick={()=>{onSelectedReportChange('FRT')}}
                            checked={selectedReport==="FRT"}/>
							<label class="conv-fontfamily-mont conv-font-w600 conv-font16 conv-txt-black form-check-label" for="flexRadioDefault5"> <span>FRT Report</span></label><br></br>
							<span class="conv-fontfamily-mont conv-font-w500 conv-font16 conv-txt-black ">(Sample File Name:FRT Report -18Aug10-49.xlsx)</span>
						</div>
                        <div class="form-check conv-mb60  radio-item">
							<input class="form-check-input" 
                            type="radio" 
                            name="flexRadioDefault" 
                            id="flexRadioDefault4" 
                            checked
                            onClick={()=>{onSelectedReportChange('SMSReport')}}
                            checked={selectedReport==="SMSReport"}/>
							<label class="conv-fontfamily-mont conv-font-w600 conv-font16 conv-txt-black form-check-label" for="flexRadioDefault4"> <span>SMS Report</span></label><br></br>
							<span class="conv-fontfamily-mont conv-font-w500 conv-font16 conv-txt-black ">(Sample File Name: SMS Report -18Aug10-49.xlsx)</span>
						</div>
                        {
                            shouldHideReports && (
                                <div class="form-check conv-mb60  radio-item">
                                    <input class="form-check-input"
                                        type="radio"
                                        name="flexRadioDefault"
                                        id="flexRadioDefault6"
                                        checked
                                        onClick={() => { onSelectedReportChange('UMCReport') }}
                                        checked={selectedReport === "UMCReport"} />
                                    <label class="conv-fontfamily-mont conv-font-w600 conv-font16 conv-txt-black form-check-label" for="flexRadioDefault6"> <span>UMC Report</span></label><br></br>
                                    <span class="conv-fontfamily-mont conv-font-w500 conv-font16 conv-txt-black ">(Sample File Name: ReqToFulfillmentUMC.xlsx)</span>
                                </div>
                            )
                        }
                    {selectedReport === 'UMCReport' ?
                        <div class="text-right">
                            <a
                                href={`${DOWNLOAD_API_URL}/static_live/Reports/ReqToFulfillmentUMC.xlsx`}
                                download="ReqToFulfillmentUMC.xlsx"
                                class="custom-download-btn"
                            >Download</a>
                        </div>
                        :
                        <div class="text-right">
                            <a href="#"
                                class="custom-download-btn"
                                onClick={() => onDownloadClick()}>Download</a>
                        </div>

                    }

                    </div>
            </div>
            <div className="col-3">
            </div>
       </div>
    )
}